import { gridSizeMdLg12, gridSizeMdLg6, useMapComponent } from "@/shared";
import { IconBtnModalMapComponent } from "@/shared/components/erp";
import { CustomTextField, CustomTextFieldNoForm } from "@/shared/components/ui";
import { IPreagendamiento } from "@/shared/interfaces";
import { Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { SaveFormDataPreagendamiento } from "../../interface/SaveFormDataPreagendamiento";

type SaveFornData = SaveFormDataPreagendamiento & {};
interface UbicacionPreagendamientoProps {
  form: UseFormReturn<SaveFornData>;
  preagendamiento: IPreagendamiento;
  errors: any;
}

const UbicacionPreagendamiento: React.FC<UbicacionPreagendamientoProps> = ({
  form,
  preagendamiento,
  errors,
}) => {
  const { Map, latLng, napsByCity } = useMapComponent({
    form,
    currentCity: "",
    distanciaNapKey: "distancia",
    coordenadasCliente: preagendamiento?.coordenadas,
    enabledFetchNaps: !!preagendamiento?.coordenadas,
  });

  return (
    <>
      <CustomTextFieldNoForm
        label="País"
        defaultValue={preagendamiento.pais_data?.nombre ?? ""}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextFieldNoForm
        label="Provincia"
        defaultValue={preagendamiento.provincia_data?.nombre ?? ""}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextFieldNoForm
        label="Ciudad"
        defaultValue={preagendamiento.ciudad_data?.nombre ?? ""}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextFieldNoForm
        label="Zona"
        defaultValue={preagendamiento.zona_data_nombre ?? ""}
        size={gridSizeMdLg6}
        disabled
      />

      <Grid item xs={12} md={11}>
        <CustomTextFieldNoForm
          disabled={true}
          label={"Coordenadas"}
          defaultValue={preagendamiento?.coordenadas || ""}
          size={gridSizeMdLg12}
        />
      </Grid>
      <Grid item xs={12} md={1}>
        <IconBtnModalMapComponent
          coords={
            `${latLng.lat},${latLng.lng}` ||
            `${form.getValues().coordenadas}` ||
            ""
          }
          btnColor="info"
          showCustomMap
          customMap={
            <Map
              coordenadas={latLng}
              napsByCity={napsByCity || []}
              canDragMarker={false}
            />
          }
        />
      </Grid>
      {/* `${latLng.lat},${latLng.lng}` || */}
      <CustomTextFieldNoForm
        label="Sector"
        defaultValue={preagendamiento.sector_data?.nombre ?? ""}
        size={gridSizeMdLg12}
        disabled
      />

      <CustomTextField
        name="direccion"
        label="Dirección"
        control={form.control}
        defaultValue={form.getValues().direccion || ""}
        error={errors.direccion}
        helperText={errors.direccion?.message?.toString() ?? ""}
        disabled
      />
    </>
  );
};
export default UbicacionPreagendamiento;
